import axios from 'axios';
import Cookies from 'js-cookie';

export const setSession = (accessToken: string | null) => {
    if (accessToken) {
        Cookies.set('accessToken', accessToken);

        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
        Cookies.remove('accessToken');

        delete axios.defaults.headers.common.Authorization;
    }
};

export const clearAuthTokens = () => {
    Cookies.remove('accessToken');
    // Cookies.removeItem('refreshToken');
};
